import {TemplatesApiClient} from "./TemplatesApiClient";
import {JSONSchema} from "../../../json-schema";
import {SearchResultDto} from "./SearchResultDto";

export class FetchApiClient implements TemplatesApiClient {
    async search(q: string, tags: string[]): Promise<SearchResultDto> {
        let urlSearchParams = new URLSearchParams();
        urlSearchParams.append("q", q);
        tags.forEach(tag => {
            urlSearchParams.append("tag", tag)
        });

        const response = await fetch(`/api/search?${urlSearchParams.toString()}`);
        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }
        return await response.json() as SearchResultDto ;
    }

    async getTemplateSchema(repoName: string, templateName: string, templateVersion?: string): Promise<JSONSchema> {
        const response = await fetch(`/api/repositories/${repoName}/templates/${templateName}/${(templateVersion == undefined ? 'latest' : templateVersion)}/values/schema`);
        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }
        return await response.json() as JSONSchema;
    }

    async getTemplateDefaults(repoName: string, templateName: string, templateVersion?: string): Promise<any> {
        const response = await fetch(`/api/repositories/${repoName}/templates/${templateName}/${(templateVersion == undefined ? 'latest' : templateVersion)}/values/defaults`);
        if (!response.ok) {
            throw new Error(`API error: ${response.statusText}`);
        }
        return await response.json() as JSONSchema;
    }
}